module.exports = __webpack_public_path__ + "img/73.85006b18.png";